import PublisherDashboard from '@/publisher/pages/Dashboard'
import PublisherSettings from '@/publisher/pages/PublisherSettings'
import PublisherMediums from '@/publisher/pages/PublisherMediums'
import PublisherMediumSettings from '@/publisher/pages/PublisherMediumSettings'
import PublisherZoneSettings from '@/publisher/pages/PublisherZoneSettings'
import TagIntegrationCode from '@/publisher/pages/Zone/TagIntegrationCode'
import Activity from '@/reports/pages/Activity'
import AdReview from '@/reports/pages/AdReview'
import AdDetails from '@/reports/pages/AdDetails'
import Explorer from '@/reports/pages/Explorer/Explorer'
import PublisherAdsTxt from "./pages/PublisherAdsTxt"

export default [
  {
    path: '/publisher/dashboard',
    name: 'PublisherDashboard',
    component: PublisherDashboard,
    meta: {
      title: 'Publisher Dashboard',
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Dashboard'}
      ]
    }
  },
  {
    path: '/publisher/:cid/settings',
    name: 'PublisherSettings',
    component: PublisherSettings,
    props: true,
    meta: {
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher Settings', to: {name: 'PublisherSettings', params: ['cid']}}
      ]
    }
  },
  {
    path: '/publisher/:cid/mediums',
    name: 'PublisherMediums',
    component: PublisherMediums,
    props: true,
    meta: {
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Mediums'}
      ]
    }
  },
  {
    path: '/publisher/:cid/mediums/:mid',
    name: 'PublisherMediumSettings',
    component: PublisherMediumSettings,
    props: true,
    meta: {
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Medium Settings'}
      ]
    }
  },
  {
    path: '/publisher/:cid/mediums/:mid/adstxt',
    name: 'PublisherAdsTxt',
    component: PublisherAdsTxt,
    props: true,
    meta: {
      permissions: ['LOGIN'],
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Medium', to: {name: 'PublisherMediumSettings', params: ['cid', 'mid']}},
        {name: 'Ads.txt'}
      ]
    }
  },
  {
    path: '/publisher/:cid/mediums/:mid/zones/:zid?',
    name: 'PublisherZoneSettings',
    component: PublisherZoneSettings,
    props: true,
    meta: {
      permissions: ['LOGIN'],
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Medium', to: {name: 'PublisherMediumSettings', params: ['cid', 'mid']}},
        {name: 'Zone Settings'}
      ]
    },
  },
  {
    path: '/publisher/:cid/mediums/:mid/zones/:zid/integration',
    name: 'TagIntegrationCode',
    component: TagIntegrationCode,
    props: true,
    meta: {
      title: 'Zone Integration Code',
      permissions: ['LOGIN'],
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Mediums', to: {name: 'PublisherMediums', params: ['cid']}},
        {name: 'Medium', to: {name: 'PublisherMediumSettings', params: ['cid', 'mid']}},
        {name: 'Zone Settings', to: { name: 'PublisherZoneSettings', params: ['cid', 'mid']}},
        {name: 'Integration'}
        ]
    }
  },
  {
    path: '/publisher/:cid/reports/activity',
    name: 'PublisherActivity',
    component: Activity,
    props: true,
    meta: {
      title: 'Publisher Reports',
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Reports'}
      ]
    }
  },
  {
    path: '/publisher/:cid/adreview',
    name: 'PublisherAdReview',
    component: AdReview,
    props: true,
    meta: {
      title: 'Live Ad Review',
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Live Ad Review'}
      ]
    }
  },
  {
    path: '/publisher/:cid/reports/review/details/:bid/:bcid/:crid',
    name: 'PublisherAdDetails',
    component: AdDetails,
    props: true,
    meta: {
      title: 'Ad Details',
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Live Ad Details'}
      ]
    }
  },
  {
    path: '/publisher/:cid/reports/explorer',
    name: 'PublisherExplorer',
    component: Explorer,
    props: true,
    meta: {
      title: 'Inventory Explorer',
      breadcrumbs: [
        {name: 'Company', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Publisher', to: {name: 'PublisherSettings', params: ['cid']}},
        {name: 'Inventory Explorer'}
      ]
    }
  }

]



// WEBPACK FOOTER //
// ./src/publisher/routes.js